import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import * as S from './SectionEnriquecaAulas.styles'
import ImageNext from '@/components/ImageNext'

const VIEWER_URL = `${process.env.CDN_URL}/unity/viewer/index.html?category=human&id=PA30046&collectionId=undefined&embedded=true&width=547px&height=502px`

const SectionEnriqueçaAulas = () => {
  const { t } = useTranslation()
  const [viewerActive, setViewerActive] = useState(false)

  return (
    <S.Section>
      <S.Title>{t('landingV2.sectionEnriquecaAulas.title')}</S.Title>
      <S.Row>
        <S.ImageCol>
          {viewerActive ? (
            <S.ViewerWrapper>
              {/* <S.ViewerCloseButton
                onClick={() => setViewerActive(false)}
                aria-label="Fechar visualizador"
              >
                &#x2715;
              </S.ViewerCloseButton> */}
              <iframe
                src={VIEWER_URL}
                width="547"
                height="502"
                style={{
                  border: 'none',
                  borderRadius: 16,
                  maxWidth: '100%',
                  width: '100%'
                }}
                allow="xr-spatial-tracking; fullscreen"
                title="Visualizador 3D BioAtlas"
              />
            </S.ViewerWrapper>
          ) : (
            <S.ImageClickable
              onClick={() => setViewerActive(true)}
              title="Clique para abrir o visualizador 3D"
            >
              <ImageNext
                src={`${process.env.CDN_URL}/public/landingpagev2/defaults/start-viewer-3d-home.png`}
                alt="Visualização 3D BioAtlas"
                width={547}
                height={502}
                style={{
                  maxWidth: '100%',
                  height: 'auto',
                  width: 'auto',
                  borderRadius: 16
                }}
                priority
              />
            </S.ImageClickable>
          )}
        </S.ImageCol>
        <S.TextCol>
          <S.Block>
            <S.BlockTitle>
              {t('landingV2.sectionEnriquecaAulas.blocks.visualizacao.title')}
            </S.BlockTitle>
            <S.BlockText>
              {t('landingV2.sectionEnriquecaAulas.blocks.visualizacao.text')}
            </S.BlockText>
          </S.Block>
          <S.Block>
            <S.BlockTitle>
              {t('landingV2.sectionEnriquecaAulas.blocks.integracao.title')}
            </S.BlockTitle>
            <S.BlockText>
              {t('landingV2.sectionEnriquecaAulas.blocks.integracao.text')}
            </S.BlockText>
          </S.Block>
          <S.Block>
            <S.BlockTitle>
              {t('landingV2.sectionEnriquecaAulas.blocks.customizacao.title')}
            </S.BlockTitle>
            <S.BlockText>
              {t('landingV2.sectionEnriquecaAulas.blocks.customizacao.text')}
            </S.BlockText>
          </S.Block>
        </S.TextCol>
      </S.Row>
    </S.Section>
  )
}

export default SectionEnriqueçaAulas
